<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <!-- 搜索区域 -->
      <a-form layout="inline">
        <a-row :gutter="10">
          <a-col :md="10" :sm="12">
            <a-form-item :label="language['user.column.userName']" style="margin-left:8px">
              <a-input :placeholder="language['warning.userAccountRequired']" v-model="queryParam.username"></a-input>
            </a-form-item>
          </a-col>
          <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
            <a-col :md="6" :sm="24">
             <a-button type="primary" @click="searchQuery" icon="search" style="margin-left: 18px">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </a-col>
          </span>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator" :md="24" :sm="24" style="margin-top: -15px">
      <!--<a-button @click="handleEdit" type="primary" icon="edit" style="margin-top: 16px">用户编辑</a-button>-->
      <a-button @click="handleAddUserDepart" type="primary" icon="plus">{{language['button.add']}}{{language['platform.roleUser.alreadyUser']}}</a-button>
      <!--<a-button @click="handleAdd" type="primary" icon="plus" style="margin-top: 16px">{{language['common.new']}}{{language['user']}}</a-button>-->

      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete"/>
            {{language['system.cancelAssociation']}}
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{language['common.batchAction']}}
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{
        selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">



        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{language['common.edit']}}</a>

          <a-divider type="vertical"/>

          <a-dropdown>
            <a class="ant-dropdown-link">
              {{language['common.more']}} <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
                <a-menu-item>
                <a href="javascript:;" @click="handleDeptRole(record)">{{language['departUser.departRole']}}</a>
              </a-menu-item>

              <a-menu-item>
                <a href="javascript:;" @click="handleDetail(record)">{{language['user']}}{{language['common.detailsButton']}}</a>
              </a-menu-item>

              <a-menu-item>
                <a-popconfirm :title="language['departUser.warning.sureCancelDepartment']" @confirm="() => handleDelete(record.id)">
                  <a>{{language['system.cancelAssociation']}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>


      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <user-modal ref="modalForm" @ok="modalFormOk"></user-modal>
    <Select-User-Modal ref="selectUserModal" @selectFinished="selectOK"></Select-User-Modal>
    <dept-role-user-modal ref="deptRoleUser"></dept-role-user-modal>
  </a-card>
</template>

<script>
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import {getAction, postAction, deleteAction} from '@/api/manage'
  import SelectUserModal from './SelectUserModal'
  import UserModal from './UserModal'
  import DeptRoleUserModal from './DeptRoleUserModal'

  export default {
    name: "DeptUserInfo",
    mixins: [JeecgListMixin],
    components: {
      DeptRoleUserModal,
      SelectUserModal,
      UserModal
    },
    computed:{
      language() {
        return this.$store.getters.language
      },
    },
    data() {
      return {
        description: '用户信息',
        currentDeptId: '',
        currentDept: {},
        // 表头
        columns: [{
            title: this.$store.getters.language['user.column.userName'],
            align: "center",
            dataIndex: 'username'
          },
          {
            title: this.$store.getters.language['user.column.realname'],
            align: "center",
            dataIndex: 'realname'
          },
          {
            title: this.$store.getters.language['depart'],
            align: "center",
            dataIndex: 'orgCode'
          },
          {
            title: this.$store.getters.language['user.column.sex'],
            align: "center",
            dataIndex: 'sex_dictText'
          },
          {
            title: this.$store.getters.language['user.column.phone'],
            align: "center",
            dataIndex: 'phone'
          },
          {
            title: this.$store.getters.language['common.action'],
            dataIndex: 'action',
            scopedSlots: {customRender: 'action'},
            align: "center",
            width: 150
          }],
        url: {
          list: "/sys/user/departUserList",
          edit: "/sys/user/editSysDepartWithUser",
          delete: "/sys/user/deleteUserInDepart",
          deleteBatch: "/sys/user/deleteUserInDepartBatch",
        }
      }
    },
    created() {
    },

    methods: {
      searchReset() {
        this.queryParam = {}
        this.loadData(1);
      },
      loadData(arg) {
        if (!this.url.list) {
          this.$message.error(this.language["platform.roleUser.pleaseSeturl.listStatus"])
          return
        }
        if(this.currentDeptId == ''){
          this.dataSource = [];
          this.ipagination.total = 0;
          return;
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        //if (this.currentDeptId === '') return;
        let params = this.getQueryParams();//查询条件
        params.depId = this.currentDeptId;
        params.applicationCode = this.$store.getters.applicationCode
        getAction(this.url.list, params).then((res) => {
          if (res.success && res.result) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
      batchDel: function () {

        if (!this.url.deleteBatch) {
          this.$message.error(this.language["platform.roleUser.pleaseSeturl.deleteBatchStatus"])
          return
        }
        if (!this.currentDeptId) {
          this.$message.error(this.language["system.warning.notDepartToAssociationUser"])
          return
        }

        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning(this.language['tip.messageSelectRecord']);
          return;
        } else {
          var ids = "";
          for (var a = 0; a < this.selectedRowKeys.length; a++) {
            ids += this.selectedRowKeys[a] + ",";
          }
          var that = this;
          this.$confirm({
            title: this.language["system,cancel.warn"],
            content: this.language["system.warning.CancelAssociationUserAnddepart"],
            onOk: function () {
              deleteAction(that.url.deleteBatch, {depId: that.currentDeptId, userIds: ids}).then((res) => {
                if (res.success) {
                  that.$message.success(this.language["operationSuccess"]);
                  that.loadData();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              });
            }
          });
        }
      },
      handleDelete: function (id) {
        if (!this.url.delete) {
          this.$message.error(this.language["platform.roleUser.pleaseSeturl.deleteStatus"])
          return
        }
        if (!this.currentDeptId) {
          this.$message.error(this.language["system.warning.notDepartToAssociationUser"])
          return
        }

        var that = this;
        deleteAction(that.url.delete, {depId: this.currentDeptId, userId: id}).then((res) => {
          if (res.success) {
            that.$message.success(this.language["operationSuccess"]);
            if (this.selectedRowKeys.length>0){
               for(let i =0; i<this.selectedRowKeys.length;i++){
                   if (this.selectedRowKeys[i] == id){
                     this.selectedRowKeys.splice(i,1);
                     break;
                   }
               }
            }
            that.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      open(record) {
        //console.log(record);
        if(record == null){
          this.currentDeptId = '';
          this.currentDept = {};
        }else{
          this.currentDeptId = record.id;
          this.currentDept = record;
        }
        this.selectedRowKeys = [];
        this.loadData(1);
      },
      clearList() {
        this.currentDeptId = '';
        this.dataSource = [];
      },
      hasSelectDept() {
        if (this.currentDeptId == '') {
          this.$message.error(this.language['common.pleaseChoose']+this.language['depart'])
          return false;
        }
        return true;
      },
      handleAddUserDepart() {
        if (this.currentDeptId == '' ) {
          this.$message.error(this.language['common.pleaseChoose']+this.language['depart'])
        } else {
          getAction("/sys/sysBmApplication/queryByCode",{"code":this.$store.getters.applicationCode}).then((res) => {
            if(res.success){
              let applicationId = res.result.id;
              this.$refs.selectUserModal.init(applicationId);
            }
          })

        }
      },
      handleEdit(record) {
        let params = {
          id: record.id,
        };
        getAction("/sys/user/getUserApplications", params).then((res)=> {
          if (res.success) {
            let apps = [];
            let list = res.result;
            if(list){
              list.forEach(item=>{
                apps.push(item.id)
              })
            }
            this.$refs.modalForm.title = this.language["common.edit"];
            record.setEdit = true;
            this.$refs.modalForm.departDisabled = true;
            this.$refs.modalForm.disableSubmit = false;
            this.$refs.modalForm.edit(record,apps);
          }
        })
      },
      handleAdd: function () {
        if (this.currentDeptId == '') {
          this.$message.error(this.language['common.pleaseChoose']+this.language['depart'])
        } else {
          this.$refs.modalForm.departDisabled = true;
          //初始化负责部门
          this.$refs.modalForm.nextDepartOptions=[{value:this.currentDept.key,label:this.currentDept.title}]
          this.$refs.modalForm.title = this.language["common.insertButton"];
          this.$refs.modalForm.userTypeDisable = true
          this.$refs.modalForm.edit({activitiSync:'1',userIdentity:1,selecteddeparts:this.currentDeptId,userType:'employee'})
        }
      },
      selectOK(data) {
        let params = {};
        params.depId = this.currentDeptId;
        params.userIdList = [];
        for (var a = 0; a < data.length; a++) {
          params.userIdList.push(data[a]);
        }
        console.log(params);
        postAction(this.url.edit, params).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.loadData();
          } else {
            this.$message.warning(res.message);
          }
        })
      },
      handleDeptRole(record){
        if(this.currentDeptId != ''){
          this.$refs.deptRoleUser.add(record,this.currentDeptId);
          this.$refs.deptRoleUser.title = this.language["column.userRole.choose"];
        }else{
          this.$message.warning(this.language['common.pleaseChoose']+this.language['depart']);
        }
      }
    }
  }
</script>
<style scoped>
  /** Button按钮间距 */
  .ant-btn {
    margin-left: 3px
  }

  .ant-card {
    margin-left: -30px;
    margin-right: -30px;
  }

  .table-page-search-wrapper {
    margin-top: -16px;
    margin-bottom: 16px;
  }
</style>